import { Injectable, inject } from '@angular/core'
import { LogService } from './log.service'
import { StorageService } from './storage.service'
import { EventService } from './event.service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { debounceTime } from 'rxjs'
import { ConfigService } from './config.service'
import { IAutofillContactDetails } from '../interfaces/form-autofill.interface'


@Injectable({
  providedIn: 'root',
})
export class FormAutofillService {

  private _logger = inject(LogService)
  private _configService = inject(ConfigService)
  private _eventService = inject(EventService)
  private _storageService = inject(StorageService)

  CONTACT_DETAILS_KEY = 'contactDetails'

  enabled = false

  constructor() {
    this._eventService.configUpdated$.pipe(
      takeUntilDestroyed(),
      debounceTime(200),
    ).subscribe(() => {
      this.enabled = this._configService.config().general.saveAutofillData
      if (!this.enabled) {
        this._storageService.removeItem(this.CONTACT_DETAILS_KEY, 'session')
      }
    })
  }

  init(): void {
    this._logger.debug('Form Autofill Service initialized')
    this.enabled = this._configService.config().general.saveAutofillData
  }

  saveContactDetails(data: IAutofillContactDetails): void {
    if (!this.enabled) {
      return
    }
    this._logger.debug('Saving contact details', data)
    this._storageService.setItem(this.CONTACT_DETAILS_KEY, JSON.stringify(data), 'session')
  }

  getContactDetails(): IAutofillContactDetails | null {
    this._logger.debug('Getting contact details')
    const data = this._storageService.getItem(this.CONTACT_DETAILS_KEY, 'session')
    if (data) {
      return JSON.parse(data)
    }
    return null
  }
}
